var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComoros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dd4446",
    d: "M0 12h30v6H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 6h30v6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8d448",
    d: "M30 6H0V0h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#163aa0",
    d: "M30 24H0v-6h30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#439543",
    d: "m0 24 15-12L0 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.96 12.54a4.5 4.5 0 0 1 3.92-5 4.63 4.63 0 1 0 0 8.92 4.5 4.5 0 0 1-3.92-3.93"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.1 8.71-.22-.66-.21.66h-.7l.56.4-.21.67.56-.41.56.4-.21-.65.56-.4zm-.22 1.38-.21.66h-.7l.56.4-.21.67.56-.4.56.4-.21-.66.56-.4h-.7zm0 2.05-.21.65h-.7l.56.41-.21.66.56-.4.56.4-.21-.66.56-.4h-.7zm.21 2.7-.21-.66-.21.66h-.7l.56.4-.21.66.56-.4.56.4-.21-.66.56-.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComoros);
export default __webpack_public_path__ + "static/media/comoros.8af8f4ba6cd87a2f3e39dbbb77328d5c.svg";
export { ForwardRef as ReactComponent };